<template>
  <ConfettiExplosion v-if="explodeVisible" :particleCount="200" :force="0.6" />
  <div class="send-sms-tab-container max-w-[600px]">
    <div class="flex flex-col w-full h-min">
      <div class="mb-4 flex w-ful flex-col px-4 md:px-0">
        <div class="sms-audience">
          <span class="font-medium">לאיזה לקוחות לשלוח את ההודעות?</span>
          <div class="flex gap-3 w-full justify-between">
            <SelectBox
              title="לכולם"
              icon="pi-users"
              :selected="clientsFilter.customersBase === MessageAddresses.All"
              @on-click="clientsFilter.customersBase = MessageAddresses.All;" />
            <SelectBox
              title="לקבוצה"
              icon="pi-users"
              :selected="clientsFilter.customersBase === MessageAddresses.Partial"
              @on-click="clientsFilter.customersBase = MessageAddresses.Partial"
            />
            <SelectBox
              title="ללקוח יחיד"
              icon="pi-users"
              :selected="clientsFilter.customersBase === MessageAddresses.User"
              @on-click="clientsFilter.customersBase = MessageAddresses.User"
            />
          </div>

          <!--    Single Customer Options    -->
          <div
            v-if="clientsFilter.customersBase === MessageAddresses.User"
            class="mt-4 gap-2 flex flex-col w-full">
            <span class="font-medium">בחרו לקוח/ה:</span>
            <Select
              v-model="clientsFilter.arg"
              :options="allCustomersList"
              optionLabel="name"
              placeholder="בחרו לקוח/ה"
              class="small-component w-full"
              optionValue="value" />
          </div>

          <!--    Sub Group Options    -->
          <div v-if="clientsFilter.customersBase === MessageAddresses.Partial" class="flex flex-col w-full mt-4 gap-2">
            <span class="font-medium">בחרו את קבוצת הלקוחות הרצויה:</span>
            <div class="flex w-full gap-3 flex-wrap justify-between">
              <SelectBox
                title="חדשים"
                icon="pi-users"
                class="h-24"
                tooltip="לקוח שהזמין תור לראשונה"
                :selected="clientsFilter.condition === MessagePartialConditions.NewUsers"
                @on-click="clientsFilter.condition = MessagePartialConditions.NewUsers" />
              <SelectBox
                title="חוזרים"
                icon="pi-users"
                class="h-24"
                :selected="clientsFilter.condition === MessagePartialConditions.ReturningUsers"
                tooltip="לקוח שכבר היה לו תור בעבר וקבע תור נוסף"
                @on-click="clientsFilter.condition = MessagePartialConditions.ReturningUsers"
              />
              <SelectBox
                title="עם תג"
                icon="pi-tag"
                class="h-24"
                :selected="clientsFilter.condition === MessagePartialConditions.ByTag"
                @on-click="clientsFilter.condition = MessagePartialConditions.ByTag" />
              <SelectBox
                title="עם תור"
                icon="pi-calendar"
                class="h-24"
                :selected="clientsFilter.condition === MessagePartialConditions.HasAppointmentInRange"
                @on-click="clientsFilter.condition = MessagePartialConditions.HasAppointmentInRange" />
              <SelectBox
                title="מועדון הלקוחות"
                icon="pi pi-verified"
                class="h-24"
                :disabled="!businessSiteData.loyaltyProgram"
                :selected="clientsFilter.condition === MessagePartialConditions.LoyaltyProgram"
                @on-click="clientsFilter.condition = MessagePartialConditions.LoyaltyProgram" />
              <SelectBox
                title="לפי נותן שירות"
                icon="pi-user"
                class="h-24"
                tooltip="לקוחות שקבעו תור עם נותן שירות ספציפי ב-3 החודשים האחרונים"
                :selected="clientsFilter.condition === MessagePartialConditions.ByProvider"
                @on-click="clientsFilter.condition = MessagePartialConditions.ByProvider" />
            </div>
          </div>

          <!--    Conditions    -->
          <div
            v-if="clientsFilter.condition === MessagePartialConditions.ByTag"
            class="mt-4 gap-2 flex flex-col w-full">
            <span class="font-medium">בחרו תגית רצויה:</span>
            <Select
              v-model="clientsFilter.arg"
              :options="tagsSuggestions"
              optionLabel="name"
              placeholder="בחרו תגית"
              class="small-component"
              optionValue="value" />
          </div>

          <div
            v-if="clientsFilter.condition === MessagePartialConditions.ByProvider"
            class="mt-4 gap-2 flex flex-col w-full">
            <span class="font-medium">בחרו נותן שירות:</span>
            <Select
              v-model="clientsFilter.arg"
              :options="providersList"
              optionLabel="name"
              placeholder="בחרו נותן שירות"
              class="small-component w-full"
              optionValue="value" />
            <span class="text-sm text-gray-500">יישלחו הודעות ללקוחות שקבעו תור עם נותן השירות הזה ב-3 החודשים האחרונים</span>
          </div>

          <div
            v-if="clientsFilter.condition === MessagePartialConditions.HasAppointmentInRange ||
        clientsFilter.condition === MessagePartialConditions.ReturningUsers ||
         clientsFilter.condition === MessagePartialConditions.NewUsers"
            class="mt-4 gap-2 flex flex-col w-full">
            <span class="font-medium">בחרו טווח תאריכים:</span>
            <ResponsiveDatePicker
              v-model="calendarDatesRange"
              mode="range"
              title="בחירת טווח תאריכים" />
          </div>

        </div>
      </div>
      <div class="mb-4 flex w-ful flex-col px-4 md:px-0 gap-2">
        <span class="font-medium">מה תרצו לשלוח?</span>
        <button
          v-if="showSenderPromo"
          type="button"
          class="flex items-center gap-2 w-full text-start rounded-lg bg-primary-50 border border-primary-200 px-3 py-2 text-sm text-primary-700"
          @click="openSenderPromo">
          <i class="pi pi-mobile" />
          <span class="flex-1">רוצים שההודעות יישלחו מהמספר של העסק?</span>
          <span class="font-medium underline whitespace-nowrap">לפרטים</span>
        </button>
        <sms-message-box ref="messageBoxRef" :filterTags="filterTags" @save-message="saveMessageContent" />
      </div>
      <div class="mb-4 flex w-ful flex-col p-4 bg-gray-100 justify-center items-center rounded-lg mx-4 md:mx-0 md:mt-4">
        <div v-if="!smsMessageContent.length || !firstStepFinished" class="not-chosen-yet">
          <img
            src="../../../../../assets/img/admin/chat.png"
          />
          <span style="font-weight: 500; text-align: center">לפני שליחת ההודעות, יש לבחור את הנמענים ונוסח ההודעה</span>
        </div>
        <div v-else-if="smsMessageContent.length && firstStepFinished && enoughSms" class="enough-sms">
          <span style="font-weight: 500; margin-bottom: 0.5rem;">אישור קטן ונשלח את ההודעות 😉</span>
          <span>כדי לשלוח הודעות לכל הנמענים שלכם, נצטרך לשלוח בערך <span style="font-weight: 500">{{
              stats.clientsMatched
            }}</span> הודעות SMS.</span>
          <span>נשארו לכם <span style="font-weight: 500">{{
              usageData?.sms?.limit - usageData?.sms?.used
            }}</span> מתוך <span
            style="font-weight: 500">{{ usageData.sms.limit }}</span> הודעות בחבילה לחודש זה.
        </span>
          <Button
            label="יש אישור"
            style="width: max-content; margin-top: 1rem; align-self: flex-end"
            v-if="!approveSending"
            @click="approveSending = true"
          />
          <Button
            v-else
            label="שליחת הודעות"
            class="my-4 w-full"
            :loading="buttonLoading"
            :disabled="!firstStepFinished || !smsMessageContent || !approveSending"
            @click="sendBulkMessages" />

        </div>
        <div v-else-if="stats.clientsMatched" class="not-enough-sms">
          <img
            src="../../../../../assets/img/admin/sms.png"
          />
          <span
            style="font-weight: 500; text-align: center">אין לכם מספיק הודעות SMS בחבילה. <br /> צרו איתנו קשר 😇</span>

        </div>
        <div v-else class="not-enough-sms">
          <img
            src="../../../../../assets/img/admin/sms.png"
          />
          <span
            style="font-weight: 500; text-align: center">בחרתם 0 לקוחות, אולי תרצו לעדכן את החיפוש?</span>

        </div>
      </div>
      <div class="flex-none w-full h-12"> </div>
    </div>
  </div>
  <SmsSenderNumberPromo :show="senderPromoVisible" @close="senderPromoVisible = false" />
</template>

<script lang="ts" setup>
import { IDropdownItem, ISmsClientsFilter, ISmsFilterStats, Plans } from '@torim-app/types';
import {
  ClientFeatures,
  IResourcesUsageData,
  MessageAddresses,
  MessagePartialConditions,
  SmsParameters
} from '@torim-app/types';

import { computed, nextTick, reactive, ref, watch } from 'vue';
import ProgressBar from 'primevue/progressbar';
import { AnalyticsApi, CommunicationApi, CustomersApi } from '@app/api/admin';
import ConfettiExplosion from 'vue-confetti-explosion';
import { useToast } from 'vue-toastification';
import SelectBox from '@app/components/admin/components/SelectBox.vue';
import { useAdminClientsStore, useAdminStore } from '@app/stores';
import { DateTime } from 'luxon';
import Select from 'primevue/select';
import ResponsiveDatePicker from '@app/components/admin/components/ResponsiveDatePicker.vue';
import { trackEvent } from '@app/composables/posthog';
import SmsSenderNumberPromo from '@app/components/admin/modals/SmsSenderNumberPromo.vue';
import { useStorage } from '@app/composables/use-storage';

const toast = useToast();
const adminStore = useAdminStore();

const smsMessageContent = ref('');
const clientsFilter = reactive<ISmsClientsFilter>(<ISmsClientsFilter>{});
const approveSending = ref(false);
const stats = reactive<ISmsFilterStats>(<ISmsFilterStats>{});
const usageData = reactive<IResourcesUsageData>(<IResourcesUsageData>{});
const explodeVisible = ref(false);
const buttonLoading = ref(false);
const messageBoxRef = ref();
const filterTags = [SmsParameters.CUSTOMER_NAME];
const tagsSuggestions = ref<IDropdownItem[]>([]);
const allCustomersList = ref<IDropdownItem[]>([]);
const calendarDatesRange = ref<Date[]>([]);

const providersList = computed<IDropdownItem[]>(() => {
  return adminStore.getProviders.map(p => ({
    value: p.userId,
    name: p.fullName
  }));
});

const firstStepFinished = computed(() => {
  if (clientsFilter.customersBase === MessageAddresses.All) return true;
  if (clientsFilter.customersBase === MessageAddresses.User && clientsFilter.arg) return true;
  if (clientsFilter.customersBase === MessageAddresses.Partial) {
    const dateRangeIsOK = calendarDatesRange.value.length === 2 && calendarDatesRange.value.every(x => x !== null);
    if (clientsFilter.condition === MessagePartialConditions.ReturningUsers && dateRangeIsOK) return true;
    if (clientsFilter.condition === MessagePartialConditions.NewUsers && dateRangeIsOK) return true;
    if (clientsFilter.condition === MessagePartialConditions.HasAppointmentInRange && dateRangeIsOK) return true;
    if (clientsFilter.condition === MessagePartialConditions.ByTag && clientsFilter.arg) return true;
    if (clientsFilter.condition === MessagePartialConditions.LoyaltyProgram) return true;
    if (clientsFilter.condition === MessagePartialConditions.ByProvider && clientsFilter.arg) return true;
  }
  return false;
});

const enoughSms = computed(() => {
  if (stats.clientsMatched && Number.isInteger(usageData?.sms?.limit) && Number.isInteger(usageData?.sms?.used))
    return stats.clientsMatched <= usageData.sms.limit - usageData.sms.used;
  return false;
});

const businessSiteData = computed(() => adminStore.businessSiteData);

// Upsell for the paid "send SMS from the business's own number" add-on (smsFromBusinessNumber).
// Auto-opens once per device (Preferences on native, localStorage on web); the inline teaser lets the user reopen it afterwards.
const SENDER_PROMO_SEEN_KEY = 'sms_sender_promo_seen';
const senderPromoVisible = ref(false);
const showSenderPromo = computed(() => !!businessSiteData.value?.bid && !businessSiteData.value.smsFromBusinessNumber);

const openSenderPromo = () => {
  trackEvent('sms_sender_promo_teaser_clicked');
  senderPromoVisible.value = true;
};

const { getValue, setValue } = useStorage();

watch(showSenderPromo, async (show) => {
  if (!show) return;
  try {
    if (await getValue(SENDER_PROMO_SEEN_KEY) === '1') return;
    await setValue(SENDER_PROMO_SEEN_KEY, '1');
  } catch (e) {
    console.error(e);
    return;
  }
  senderPromoVisible.value = true;
}, { immediate: true });

const getUsageData = async () => {
  const usageDataResponse = await AnalyticsApi.fetchResourcesUsage();
  Object.assign(usageData, usageDataResponse);
};

const getTags = async () => {
  const { suggestions } = await CustomersApi.fetchTagsAndSuggestions();
  tagsSuggestions.value.splice(0);
  tagsSuggestions.value.push(...suggestions.map<IDropdownItem>(s => ({
    value: s,
    name: s
  })));
};

const saveMessageContent = (msg: string) => {
  smsMessageContent.value = msg;
};

const explode = async () => {
  explodeVisible.value = false;
  await nextTick();
  explodeVisible.value = true;
};

const sendBulkMessages = () => {
  trackEvent('sms_sent');
  buttonLoading.value = true;
  CommunicationApi.sendBulkSMSbyFilter(clientsFilter, smsMessageContent.value)
    .then(_ => {
      explode();
      buttonLoading.value = false;
      resetAll();
    })
    .catch(err => {
      toast.error('לא הצלחנו לשלוח את ההודעות 😢');
      buttonLoading.value = false;
      console.error(err);
    });
};

const resetAll = () => {
  explodeVisible.value = false;
  smsMessageContent.value = '';
  Object.assign(clientsFilter, {
    customersBase: null,
    condition: null,
    lastXDays: null
  });
  approveSending.value = false;
  messageBoxRef.value?.clearMessage?.();
  getUsageData();
};

watch(() => clientsFilter.customersBase, async () => {
  clientsFilter.condition = undefined;
  clientsFilter.dateRange = undefined;
  clientsFilter.arg = undefined;

  if (clientsFilter.customersBase === MessageAddresses.User) {
    const clientsStore = useAdminClientsStore();
    if (clientsStore.getClients.length === 0)
      await clientsStore.fetchBusinessCustomers();

    allCustomersList.value.splice(0);
    allCustomersList.value.push(...clientsStore?.getClients?.map(c => ({
      value: c.id!,
      name: c.fullName
    })));
  }
});

watch(() => clientsFilter.condition, () => {
  clientsFilter.arg = undefined;
  calendarDatesRange.value.splice(0);
  if (clientsFilter.condition === MessagePartialConditions.ByTag)
    getTags();
});

watch(firstStepFinished, () => {
  if (firstStepFinished.value) {
    if (calendarDatesRange.value.length > 0) {
      clientsFilter.dateRange = {
        start: DateTime.fromJSDate(calendarDatesRange.value[0]).toISODate()!,
        end: DateTime.fromJSDate(calendarDatesRange.value[1]).toISODate()!
      };
    }
    CommunicationApi.fetchFilterEstimatedClients(clientsFilter)
      .then(res => {
        Object.assign(stats, res);
        approveSending.value = false;
      }).catch(err => {
      console.error(err);
    });
  }
});

watch(() => clientsFilter?.arg, () => {
  if (clientsFilter.arg)
    CommunicationApi.fetchFilterEstimatedClients(clientsFilter)
      .then(res => {
        Object.assign(stats, res);
        approveSending.value = false;
      }).catch(err => {
      console.error(err);
    });
});

// TODO: Optimize and get it from the store
getUsageData();

</script>

<style scoped lang="scss">
.send-sms-tab-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  flex-grow: 1;

  .message-progress {
    height: 0.75rem;
    margin-bottom: 1rem;
  }

  .sms-audience {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 0.5rem;

    .days-input {
      max-width: 5rem;

      .p-inputtext, .p-inputnumber-input {
        max-width: 5em !important;
      }
    }

  }

  .enough-sms {
    display: flex;
    flex-direction: column;
    line-height: 1.35rem;
  }

  .not-chosen-yet, .not-enough-sms {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 2rem;

    img {
      margin-bottom: 1rem;
    }
  }

}
</style>
